import React, { useState, useEffect } from 'react';
import { API_URL } from '../utils/api';

const Changelog = () => {
    const [changes, setChanges] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchChangelog = async () => {
            try {
                const res = await fetch(`${API_URL}/api/changelog/`);
                if (res.ok) {
                    const data = await res.json();
                    if (data.releases && data.releases.length > 0) {
                        setChanges(data.releases);
                    } else {
                        setChanges(staticChanges);
                    }
                } else {
                    setChanges(staticChanges);
                }
            } catch (error) {
                console.error("Error fetching changelog:", error);
                setChanges(staticChanges);
            } finally {
                setLoading(false);
            }
        };

        fetchChangelog();
    }, []);

    const staticChanges = [
        {
            version: 'v2.0',
            date: '10. Mai 2026',
            features: [
                'Admin-Dashboard 2.0: Interaktive Diagramme (Lernstatus-Donut & 7-Tage-Aktivität) statt reiner Zahlen.',
                'QR-Vernetzung: Jeder Nutzer hat nun einen persönlichen QR-Code und Einladungslink zum direkten Teilen via WhatsApp/Telegram.',
                'Mobile Wetter-Integration: Temperatur-Anzeige im Header und klickbarer Wetter-Eintrag im mobilen Menü.',
                'PdW-Optimierung: Kompakteres Layout der "Pflanze der Woche"-Liste für bessere Übersicht auf allen Geräten.',
                'Zertifikats-Redesign: Offizielle Urkunden mit Siegel, Seriennummer und optimierter Typografie.'
            ]
        },
        {
            version: 'v1.9.0',
            date: '26. April 2026',
            features: [
                'Admin-Monitoring 2.0: Neues Dashboard für die Test-Verwaltung mit grafischer Auswertung und Echtzeit-Fortschrittsanzeige.',
                'Visual Test-Audit: Intuitive Ampel-Anzeige für detaillierte Testergebnisse.',
                'Infrastruktur-Monitoring: Automatisierte Überwachung der System-Gesundheit und Dienst-Verfügbarkeit.',
                'Premium Dashboard UX: Verbesserte Lesbarkeit und Kontraste, optimiert für den Dark Mode.',
                'System-Stabilität: Optimierte Schnittstellen für eine zuverlässige Test-Ausführung.',
                'Security-Monitor: Neues Interface zur Überwachung der Plattform-Sicherheit.'
            ]
        },
        {
            version: 'v1.8.0',
            date: '22. April 2026',
            features: [
                'CI-Harmonisierung: Projektweite Standardisierung der Farbvariablen (Emerald/GaLaBau-Grün) für ein konsistentes Branding.',
                'Marken-Identität: Integration des neuen offiziellen Plantlix-Favicons.',
                'Flashcard-UX: Größere Pflanzenbilder und optimiertes Karten-Layout für effektiveres Lernen.',
                'Geometrie-Fix: Korrektur der Karten-Zentrierung und Abstände auf mobilen Endgeräten.'
            ]
        },
        {
            version: 'v1.7.0',
            date: '16. April 2026',
            features: [
                'Herbarium-Generator: Neuer professioneller PDF-Export für A4-Herbariumsblätter mit automatischer Stammdaten-Box.',
                'Magic Fill & Verify: Ein-Klick-Recherche mit KI, automatischer Kürzung auf Zeichenlimits (80/200) und sofortiger Speicherung.',
                'Datenintegrität 2.0: Strikter Schutz von Botanischem Namen, Familie und Kategorie gegen KI-Fehlinterpretationen.',
                'UI-Boost: Neues, hochkompaktes Design der PdW-Übersichtsliste für schnellere Bearbeitung und bessere Übersicht.',
                'Stabilitäts-Fixes: Bereinigung kritischer Syntaxfehler im Frontend für einen stabilen Produktionsbetrieb.'
            ]
        },
        {
            version: 'v1.6.0',
            date: 'April 2026',
            features: [
                'Batch PDW Automatisierung: Pflanzen-Bestiary erlaubt nun Mehrfachauswahl und automatisische Kalenderwochen-Zuweisung.',
                'Automatisierte KI-Recherche: Vollständiges Ausfüllen von Pflanzenberichten inkl. Blütezeiträumen (I-XII), Kalk- und pH-Werten.',
                'Checkbox-Synchronisierung: Automatische Erkennung von Status-Flags wie Züchtung, Wildpflanze oder Artenschutz.',
                'PDF-Kalibrator Upgrade: Verbesserte Bedienbarkeit und neue Tastenkombination (Alt + Shift + C).'
            ]
        },
        {
            version: 'v1.5.0',
            date: 'April 2026',
            features: [
                'Full Integration "Sign in with Apple" (Web & App)',
                'AES-256 Verschlüsselung für sensible Ausbildungsdaten',
                'Optimierte HTTPS-Sicherheit für Proxy-Deployments',
                'Verbesserte Datenintegrität bei verschlüsselten Berichten',
                'Fix: Referer-Header Problematik bei der Anmeldung gelöst'
            ]
        },
        {
            version: 'v1.4.0',
            date: 'März 2026',
            features: [
                'Verbessertes Pflanzen-Bestiary mit neuer Zoom-Funktion',
                'Optimierte Darstellung auf Tablets und großen Bildschirmen',
                'Erhöhte Stabilität und Fehlerbehebungen beim Quiz',
                'Auswertungsseite im Profil zeigt jetzt gesammelte Statistiken zuverlässig an',
                'Neue Scrollbar im Plantlix-Design (CI)',
                'Verbesserungen im Ausbildungsnachweis (Automatische Weiterleitung)'
            ]
        },
        {
            version: 'v1.3.0',
            date: 'Februar 2026',
            features: [
                'Neue PDF-Exportfunktion für Ausbildungsnachweise',
                'Pflanze der Woche: Erweiterte Ansichten und Druckversion',
                'Wetterdaten werden nun automatisch für Berichte bezogen',
                'Verbesserte Responsivität der Karten',
                'Performance-Updates im Bestiary'
            ]
        },
        {
            version: 'v1.2.0',
            date: 'Frühjahr 2026',
            features: [
                'Einführung des Ausbilder-Dashboards',
                'Neue Quizze: Multiple-Choice, Lernkarten und Erkennung',
                'Community-Features: Sniggeln, Freunde und Badges'
            ]
        }
    ];

    const formatVersion = (v) => {
        if (!v) return '';
        // "v2.0.1" -> "v2.0"
        // "1.9.0" -> "1.9"
        const parts = v.split('.');
        if (parts.length >= 2) {
            return `${parts[0]}.${parts[1]}`;
        }
        return v;
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-plantlix-500"></div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-8 max-w-4xl">
            <h1 className="text-3xl font-bold mb-8 text-gray-800 dark:text-gray-100 flex items-center gap-3">
                <span className="text-plantlix-500">🚀</span> Changelog
            </h1>
            
            <div className="space-y-12">
                {changes.map((release, idx) => (
                    <div key={idx} className="relative pl-8 border-l-2 border-gray-100 dark:border-gray-800 pb-2">
                        {/* Timeline dot */}
                        <div className="absolute left-[-9px] top-0 w-4 h-4 rounded-full bg-plantlix-500 border-4 border-white dark:border-[#0a0a0a] shadow-sm"></div>
                        
                        <div className="flex flex-wrap items-baseline gap-3 mb-4">
                            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                                {formatVersion(release.version)}
                            </h2>
                            {release.title && (
                                <span className="text-lg text-gray-600 dark:text-gray-400 font-medium">
                                    – {release.title}
                                </span>
                            )}
                            <span className="ml-auto text-sm font-semibold bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400 px-3 py-1 rounded-full uppercase tracking-wider">
                                {release.date}
                            </span>
                        </div>

                        {release.description && (
                            <p className="text-gray-600 dark:text-gray-400 mb-4 leading-relaxed">
                                {release.description}
                            </p>
                        )}

                        <div className="space-y-6">
                            {release.features && release.features.length > 0 && (
                                <div>
                                    <h3 className="text-sm font-bold text-emerald-600 dark:text-emerald-400 uppercase tracking-widest mb-3 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full bg-emerald-500"></span>
                                        Neuheiten & Features
                                    </h3>
                                    <ul className="space-y-2">
                                        {release.features.map((feature, fIdx) => (
                                            <li key={fIdx} className="text-gray-700 dark:text-gray-300 flex items-start gap-3">
                                                <span className="text-emerald-500 mt-1.5">•</span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {release.improvements && release.improvements.length > 0 && (
                                <div>
                                    <h3 className="text-sm font-bold text-blue-600 dark:text-blue-400 uppercase tracking-widest mb-3 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                                        Verbesserungen
                                    </h3>
                                    <ul className="space-y-2">
                                        {release.improvements.map((improvement, iIdx) => (
                                            <li key={iIdx} className="text-gray-700 dark:text-gray-300 flex items-start gap-3">
                                                <span className="text-blue-500 mt-1.5">•</span>
                                                {improvement}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {release.fixes && release.fixes.length > 0 && (
                                <div>
                                    <h3 className="text-sm font-bold text-amber-600 dark:text-amber-400 uppercase tracking-widest mb-3 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full bg-amber-500"></span>
                                        Fehlerbehebungen
                                    </h3>
                                    <ul className="space-y-2">
                                        {release.fixes.map((fix, fxIdx) => (
                                            <li key={fxIdx} className="text-gray-700 dark:text-gray-300 flex items-start gap-3">
                                                <span className="text-amber-500 mt-1.5">•</span>
                                                {fix}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-16 p-8 rounded-2xl bg-gradient-to-br from-gray-50 to-white dark:from-[#0f172a] dark:to-[#0a0a0a] border border-gray-100 dark:border-gray-800 text-center">
                <p className="text-gray-500 dark:text-gray-400 mb-2">
                    Du hast einen Bug gefunden oder einen Feature-Wunsch?
                </p>
                <a 
                    href="mailto:support@plantlix.de" 
                    className="text-plantlix-600 dark:text-plantlix-400 font-bold hover:underline"
                >
                    Schreib uns einfach!
                </a>
            </div>
        </div>
    );
};

export default Changelog;
